<template>
  <div>
    <form data-vv-scope="CourseScheduling"> 
    <div class="border_btm py-2">
      <h4 class="mb-4">Course Scheduling</h4>
      <vs-row>
        <vs-col vs-lg="9" vs-sm="12" class="sm:pr-4 pr-0">
          <vs-row>
            <vs-col vs-lg="3" vs-sm="12" class="p-2">
              <label class="vs-input--label">Scheduling</label>
              <v-select
              :disabled="course_data.is_purchased"
              :selectable="option =>option.selectable"
                :reduce="option => option.id"
                label="name"
                class="cstm_vue_select w-full"
                :options="schedulings"
                v-model="courseScheduleSetting.schedule_type"
                placeholder="Select"
              ></v-select>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="12" class="p-2">
              <label class="vs-input--label">Number of Sessions</label>
              <vs-input
              :disabled="course_data.is_purchased"
               onkeypress="return (event.charCode >= 48)"
               min="0"
              type="number"
                class="cstm_vue_select w-full"
                v-model="courseScheduleSetting.no_of_sessions"
                placeholder="Select"
              />
            </vs-col>
            <template v-if="courseScheduleSetting.schedule_type == 1">
              <vs-col vs-lg="4" vs-sm="12" class="p-2">
                <label
                  class="vs-input--label inline-flex items-center justify-between w-full"
                >
                  <span class="pr-1">Enrollment Deadline</span>
                  <vs-switch
                    class=""
                    v-model="courseScheduleSetting.has_enrollment_deadline"
                  />
                </label>
                <flat-pickr
                  v-if="courseScheduleSetting.has_enrollment_deadline"
                  class="w-full"
                  :config="courseScheduleSetting.enrollment_deadline!=''? {'minDate':courseScheduleSetting.enrollment_deadline, enableTime: true}: {'minDate':'today', enableTime: true}"
                  v-model="courseScheduleSetting.enrollment_deadline"
                />
              </vs-col>
            </template>
            <template v-if="courseScheduleSetting.schedule_type == 2">
              <vs-col vs-lg="2" vs-sm="12" class="p-2">
                <label class="vs-input--label required">Session Duration</label>
                <v-select
                  v-validate="'required'"
                  label="name"
                  v-model="courseScheduleSetting.session_duration_id"
                  :reduce="option => option.id"
                  :options="durationsArray"
                  class="cstm_vue_select w-full pr-1"
                  placeholder="Select"
                  data-vv-name="session duration"
                ></v-select>
                <span
                v-show="errors.has('CourseScheduling.session duration')"
                class="text-danger block"
                >{{ errors.first('CourseScheduling.session duration') }}</span
              >
              </vs-col>
              <vs-col
                vs-lg="3"
                vs-sm="12"
                class="p-2"
                v-if="courseScheduleSetting.session_duration_id == 7"
              >
                <label class="vs-input--label">Enter Custom Duration</label>
                <div class="flex">
                  <vs-input
                    v-model="courseScheduleSetting.custom_session_duration_no"
                    onkeypress="return (event.charCode >= 48)"
                    min="0"
                    type="number"
                    class="cstm_vue_select w-full pr-1"
                    placeholder="Enter here..."
                  />
                  <v-select
                    v-model="courseScheduleSetting.custom_session_duration_type"
                    :options="sessionfrequencyArray"
                    class="cstm_vue_select w-full"
                    placeholder="Select"
                    label="name"
                    :reduce="option => option.id"
                  ></v-select>
                </div>
              </vs-col>
              <vs-col vs-lg="2" vs-sm="12" class="p-2">
                <label class="vs-input--label required">Session Frequency</label>
                <v-select
                  v-validate="'required'"
                  label="name"
                  v-model="courseScheduleSetting.session_frequency_id"
                  :reduce="option => option.id"
                  :options="frequencyArray"
                  class="cstm_vue_select w-full"
                  placeholder="Select"
                  data-vv-name="session frequency"
                ></v-select>
                <span
                v-show="errors.has('CourseScheduling.session frequency')"
                class="text-danger block"
                >{{ errors.first('CourseScheduling.session frequency') }}</span
              >
              </vs-col>
            </template>
          </vs-row>
        </vs-col>
        <vs-col
          vs-lg="3"
          vs-sm="12"
          class="sm:pl-6 pl-0"
          v-if="courseScheduleSetting.schedule_type == 2"
        >
          <vs-row>
            <vs-col vs-w="12" class="p-2">
              <label class="vs-input--label">Earliest Course Start </label>
              <div class="flex">
                <vs-input
                v-model="courseScheduleSetting.earliest_course_start_no"
                 onkeypress="return (event.charCode >= 48)"
                 min="0"
                  type="number"
                  class="cstm_vue_select w-full pr-1"
                  placeholder="Enter here..."
                />
                <v-select
                v-model="courseScheduleSetting.earliest_course_start_type"
                :reduce="option => option.id"
                label="name"
                  :options="earliest"
                  class="cstm_vue_select w-full"
                  placeholder="Select"
                ></v-select>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </div>
    <!-- sessions -->
    <template v-if="courseScheduleSetting.schedule_type == 1">
      <div class="border_btm pt-4">
        <h5 class="mb-4">Sessions</h5>
        <div class="sessions_outer_holder pb-2">
          <div
            class="sessions_holder"
            v-for="(each, index) in courseScheduleSetting.courseFixedSchedules"
            :key="index"
          >
            <span class="name">Session {{ index + 1 }}</span>
            <vs-row>
              <vs-col vs-lg="2" vs-sm="12" class="p-2">
                <label class="vs-input--label required">Select Date</label>
                <flat-pickr class="w-full" v-validate="'required'" data-vv-as = "start date" :data-vv-name="`start date ${index+ 1}`" :config="each.schedule_date!=''? {'minDate':each.schedule_date}: {'minDate':'today'}" v-model="each.schedule_date" />
                 <span
                v-show="errors.has(`CourseScheduling.start date ${index+ 1}`)"
                class="text-danger block"
                >{{ errors.first(`CourseScheduling.start date ${index+ 1}`) }}</span
              >
              </vs-col>
              <vs-col vs-lg="2" vs-sm="12" class="p-2">
                <label class="vs-input--label required">Start Time</label>
                <flat-pickr
                 v-validate="'required'" data-vv-as = "start time" :data-vv-name="`start time ${index+1}`"
                  :config="configTime"
                  class="w-full"
                  v-model="each.schedule_from_time"
                />
                 <span
                v-show="errors.has(`CourseScheduling.start time ${index+1}`)"
                class="text-danger block"
                >{{ errors.first(`CourseScheduling.start time ${index+1}`) }}</span
              >
              </vs-col>
              <vs-col vs-lg="2" vs-sm="12" class="p-2">
                <label class="vs-input--label required">End Time</label>
                <flat-pickr
                v-validate="'required'" data-vv-as = "end time" :data-vv-name="`end time ${index+1}`"
                  :config="{
                    enableTime: true,
                    noCalendar: true,
                    minTime:each.schedule_from_time
                  }"
                  class="w-full"
                  v-model="each.schedule_to_time"
                />
                 <span
                v-show="errors.has(`CourseScheduling.end time ${index+1}`)"
                class="text-danger block"
                >{{ errors.first(`CourseScheduling.end time ${index+1}`) }}</span
              >
              </vs-col>
              <vs-col vs-lg="2" vs-sm="12" class="p-2">
                <label class="vs-input--label">Select Room</label>
                <v-select
                  :reduce="option => option.assets_id"
                  label="name"
                  :options="roomList"
                  placeholder="Choose Room"
                  class="cstm_vue_select w-full"
                  @open="onOpenRoom"
                  @close="onCloseRoom"
                  v-model="each.room_id"
                >
                  <template #list-footer>
                    <li
                      ref="loadRooms"
                      class="loader"
                      v-show="room_meta.has_next"
                    >
                      Loading more rooms...
                    </li>
                  </template>
                </v-select>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="12" class="p-2">
                <label class="vs-input--label">Select Teacher</label>
                <v-select
                  multiple
                  :getOptionLabel="
                    item => `${item.first_name} ${item.last_name}`
                  "
                  class="w-full"
                  placeholder="Select Teacher"
                  :clearable="false"
                  @open="onOpenTeacher(index)"
                  @search="fuseSearch"
                  @close="onCloseTeacher"
                  :options="teacherList"
                  v-model="each.users"
                >
                  <template v-slot:selected-option="teacherList">
                    <img
                      v-if="teacherList.picture"
                      class="person-img rounded-full"
                      :src="teacherList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ teacherList.first_name }}
                    {{ teacherList.last_name }}
                  </template>
                  <template v-slot:option="teacherList">
                    <img
                      v-if="teacherList.picture"
                      class="person-img rounded-full"
                      :src="teacherList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ teacherList.first_name }}
                    {{ teacherList.last_name }}
                  </template>
                  <template #list-footer>
                    <li
                      :class="'loader loadTeacher'+index"
                      
                      v-show="teacher_meta.has_next"
                    >
                      Loading more teacher...
                    </li>
                  </template>
                </v-select>
              </vs-col>
              <vs-col vs-lg="1" vs-sm="12" class="inline-flex justify-end p-2">
                <vs-tooltip text = "Duplicate">
                <span
                  style="cursor: pointer;"
                  class="material-icons-outlined pb-2"
                  @click="duplicate(index)"
                  >content_copy</span
                >
                </vs-tooltip>
                <vs-tooltip text = "Remove">
                <span
                  style="cursor: pointer;"
                  class="material-icons-outlined pb-2"
                  @click="remove(index)"
                  >delete</span
                >
                </vs-tooltip>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </div>
    </template>

    <!-- for dynamic schedule -->
    <template v-if="courseScheduleSetting.schedule_type == 2">
      <div class="border_btm py-4">
        <vs-row>
          <vs-col vs-lg="4" vs-sm="12" class="sm:pr-2 pr-0">
            <div
              class="flex flex-wrap justify-between items-center grey_holder p-4"
            >
              <span>Allow lessons even if tutor is not available</span>
              <vs-switch
                v-model="courseScheduleSetting.allow_lessons_for_na_tutors"
              />
            </div>
          </vs-col>
           <vs-col vs-lg="4" vs-sm="12" class="sm:pr-2 pr-0">
            <div
              class="flex flex-wrap justify-between items-center grey_holder p-4"
            >
              <span>Allow lessons outside school hours</span>
              <vs-switch
                v-model="courseScheduleSetting.allow_lessons_outside_school_hours"
              />
            </div>
          </vs-col>
          <vs-col vs-lg="4" vs-sm="12" class="sm:pl-2 pl-0">
            <div
              class="flex flex-wrap justify-between items-center grey_holder p-4"
            >
              <span>Allow lessons during school holidays</span>
              <vs-switch
                v-model="
                  courseScheduleSetting.allow_lessons_during_school_holidays
                "
              />
            </div>
          </vs-col>
        </vs-row>
      </div>
    </template>

    <vs-row class="border_btm py-4">
      <!-- teacher rescheduling -->
      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <div class="grey_border h-full p-4">
          <div class="flex flex-wrap justify-between items-center mb-6">
            <h4>Teacher Rescheduling</h4>
            <vs-switch v-model="courseScheduleSetting.teacher_reschedule" />
          </div>
          <vs-row v-if="courseScheduleSetting.teacher_reschedule">
            <vs-col vs-w="12" class="py-2">
              <label class="vs-input--label">Number of reschdules</label>
              <vs-input
               onkeypress="return (event.charCode >= 48)"
               min="0"
                v-model="courseScheduleSetting.max_teacher_reschedule"
                placeholder="Enter"
                type="number"
                class="w-full"
              />
            </vs-col>
            <vs-col vs-w="12" class="py-2 position-relative">
              <label
                class="vs-input--label inline-flex justify-between items-center"
              >
                <span>Minimum Required Notice Period</span>
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  The minimum required timeframe prior to the session being rescheduled by the teacher. If no selection is made, then it is assumed that no notice period is required.
                </div>
              </label>
              <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <vs-input
                 onkeypress="return (event.charCode >= 48)"
                 min="0"
                  class="w-full"
                  placeholder="Enter.. "
                  type="number"
                  v-model="
                    courseScheduleSetting.minimum_notice_period_for_teachers_no
                  "
                />
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <v-select
                  class="cstm_vue_select"
                  :options="sessionfrequencyArray"
                  label="name"
                  :reduce="option => option.id"
                  placeholder="Select"
                  v-model="
                    courseScheduleSetting.minimum_notice_period_for_teachers_type
                  "
                ></v-select>
              </vs-col>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>

      <!-- student rescheduling -->
      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <div class="grey_border h-full p-4">
          <div class="flex flex-wrap justify-between items-center mb-6">
            <h4>Student Rescheduling</h4>
            <vs-switch :disabled="courseScheduleSetting.schedule_type==1" v-model="courseScheduleSetting.student_reschedule" />
          </div>
          <vs-row v-if="courseScheduleSetting.student_reschedule">
            <vs-col vs-w="12" class="py-2">
              <label class="vs-input--label">Number of reschdules</label>
              <vs-input
               onkeypress="return (event.charCode >= 48)"
               min="0"
                v-model="courseScheduleSetting.max_student_reschedule"
                placeholder="Enter"
                type="number"
                class="w-full"
              />
            </vs-col>
            <vs-col vs-w="12" class="py-2 position-relative">
              <label
                class="vs-input--label inline-flex justify-between items-center"
              >
               
               <span>Minimum Required Notice Period</span>
                
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  The minimum required timeframe prior to the session being rescheduled by the student. If no selection is made, then it is assumed that no notice period is required.
                </div>
              </label>
              <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <vs-input
                 onkeypress="return (event.charCode >= 48)"
               min="0"
                type="number"
                  class="w-full"
                  placeholder="Enter.. "
                  v-model="
                    courseScheduleSetting.minimum_notice_period_for_students_no
                  "
                />
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <v-select
                  class="cstm_vue_select"
                  :options="sessionfrequencyArray"
                  label="name"
                  :reduce="option => option.id"
                  placeholder="Select"
                  v-model="
                    courseScheduleSetting.minimum_notice_period_for_students_type
                  "
                ></v-select>
              </vs-col>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>

      <!-- renew and cancellation -->
      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <div class="grey_border h-full p-4">
          <div class="flex flex-wrap justify-between items-center mb-6">
            <h4>Renew and Cancellation</h4>
          </div>
          <!-- Calendar Placeholder buffer -->
          <vs-row>
            <vs-col vs-lg="9" vs-sm="12" class="py-1 position-relative">
              <label
                class="vs-input--label inline-flex justify-between items-center"
              >
                <span>Calendar Placeholder buffer</span>
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  The calendar placeholder buffer blocks out calendar slots starting from the end date of the course to the specified buffer period, so that these slots become unavailable for others. This option is recommended for automatic renewal.
                </div>
              </label>
              <vs-col vs-lg="5" vs-sm="12" class="p-1" v-if="courseScheduleSetting.calender_placeholder_buffer">
                <vs-input
                 onkeypress="return (event.charCode >= 48)"
               min="0"
                type="number"
                  class="w-full"
                  v-model="
                    courseScheduleSetting.calender_placeholder_buffer_type_no
                  "
                  placeholder="Enter"
                />
              </vs-col>
              <vs-col vs-lg="7" vs-sm="12" class="p-1" v-if="courseScheduleSetting.calender_placeholder_buffer">
                <v-select
                class="cstm_vue_select w-full"
                  placeholder="Select"
                  v-model="
                    courseScheduleSetting.calender_placeholder_buffer_type_id
                  "
                  :reduce="option => option.id"
                  label="name"
                  :options="bufferArray"
                ></v-select>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="12" class="flex justify-end py-2">
              <vs-switch
                v-model="courseScheduleSetting.calender_placeholder_buffer"
              />
            </vs-col>
          </vs-row>
          <!-- Minimum Required Notice Period -->
          <vs-row>
            <vs-col vs-lg="9" vs-sm="12" class="py-1 position-relative">
              <label
                class="vs-input--label inline-flex justify-between items-center"
              >
               <span>Notice Period for Cancellation</span>
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  This option allows a student to cancel midway through the course with the specified notice period.
                </div>
              </label>
              <vs-col vs-lg="5" vs-sm="12" class="p-1" v-if="courseScheduleSetting.notice_period_for_cancellation">
                <vs-input
                  class="w-full"
                   onkeypress="return (event.charCode >= 48)"
               min="0"
                  type="number"
                  v-model="
                    courseScheduleSetting.notice_period_for_cancellation_no
                  "
                  placeholder="Enter"
                />
              </vs-col>
              <vs-col vs-lg="7" vs-sm="12" class="p-1" v-if="courseScheduleSetting.notice_period_for_cancellation">
                <v-select
                  class="cstm_vue_select"
                  placeholder="Select"
                  v-model="
                    courseScheduleSetting.notice_period_for_cancellation_type_id
                  "
                  :reduce="option => option.id"
                  label="name"
                  :options="bufferArray"
                ></v-select>
              </vs-col>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="12" class="flex justify-end py-2">
              <vs-switch
                v-model="courseScheduleSetting.notice_period_for_cancellation"
              />
            </vs-col>
          </vs-row>
          <!-- Automatic Renewal -->
          <vs-row>
            <vs-col vs-lg="9" vs-sm="12" class="py-1 position-relative">
              <label
                class="vs-input--label inline-flex justify-between items-center"
              >
                <span>Automatic Renewal</span>
                <span class="material-icons-outlined info_pointer">info</span>
                <div class="tooltip_holder">
                  The automatic renewal option when enabled, allows the course to be automatically be renewed once completed. The course will renew with the same number of sessions, duration and frequency and same type of payment.
                </div>
              </label>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="12" class="flex justify-end py-2">
              <vs-switch v-model="courseScheduleSetting.auto_renewal" />
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>
        <div class="flex flex-wrap justify-between items-center mt-4">
       <vs-button type="border" @click="prevPage()" v-if="!$route.params.course_id"
      >Back</vs-button
    >
    <vs-button @click="createCourseSchedule()" 
      >Save & Next</vs-button
    >
    </div>
    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { RoomListApi } from '@/api/room'
import { fetchUserClient } from '@/api/task-project.js'

//import { CourseBuilder } from "../mixin/courseBuilderMixin";

import {
  updateCourseScheduleSetting,
  getCourseScheduleSetting, 
  getCourseContent
} from '@/api/courseBuilder.js'

export default {
  //mixins: [CourseBuilder],
  props: {
    courseId: {
      required: true,
      default: null
    },
    counter: {
      required: true,
      default: 0
    }
  },
  watch: {
    counter () {
      // if (this.counter === 2) {
      this.course_id = this.courseId
      this.getScheduleDetails()
      this.fetchroomList()
      this.getTeacherList()
    //  }
      
      
    }
  },
  created () {
   
  },
  data () {
    return {
      observer: new IntersectionObserver(this.loadMoreTeacher),
      course_data:null,
      observerRoom: new IntersectionObserver(this.loadMoreRooms),
      room_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      roomList: [],
      durationsArray: [
        {
          id: 1,
          name: '15 Min'
        },
        {
          id: 2,
          name: '30 Min'
        },
        {
          id: 3,
          name: '45 Min'
        },
        {
          id: 4,
          name: '60 Min'
        },
        {
          id: 5,
          name: '75 Min'
        },
        {
          id: 6,
          name: '90 Min'
        },
        {
          id: 7,
          name: 'Custom'
        }
      ],
      frequencyArray: [
        {
          id: 1,
          name: 'daily'
        },
        {
          id: 2,
          name: 'weekly'
        },
        {
          id: 3,
          name: 'monthly'
        },
        {
          id: 4,
          name: 'yearly'
        }
      ],
      earliest:[
        {
          id: 1,
          name: 'Minutes'
        },
        {
          id: 2,
          name: 'Hours'
        },
        {
          id: 3,
          name: 'Days'
        },
        {
          id: 4,
          name: 'Weeks'
        },
        {
          id: 5,
          name: 'Months'
        }
      ],
      sessionfrequencyArray: [
        {
          id: 1,
          name: 'Minutes'
        },
        {
          id: 2,
          name: 'Hours'
        },
        {
          id: 3,
          name: 'Days'
        }
      ],
      bufferArray: [
        {
          id: 1,
          name: 'Days'
        },
        {
          id: 2,
          name: 'Weeks'
        },
        {
          id: 3,
          name: 'Months'
        }
      ],
      scheduleaMindate: {
        minDate:'today'
      },
      configTime: {
        enableTime: true,
        noCalendar: true
      },
      deadlineConfig: {
        enableTime: true,
        minDate:'today'
      },
      courseScheduleSetting: {
        earliest_course_start_no:null,
        earliest_course_start_type:null,
        schedule_type: null,
        session_duration_id: null,
        session_frequency_id: null,
        no_of_sessions: 1,
        calender_placeholder_buffer_type_no: null,
        calender_placeholder_buffer_type_id: null,
        allow_lessons_during_school_holidays: false,
        allow_lessons_for_na_tutors: false,
        allow_lessons_outside_school_hours: false,
        has_enrollment_deadline: false,
        auto_renewal: false,
        enrollment_deadline: null,
        teacher_reschedule: true,
        student_reschedule: false,
        calender_placeholder_buffer: false,
        notice_period_for_cancellation: false,
        custom_session_duration_no: '',
        custom_session_duration_type: '',
        max_student_reschedule: null,
        max_teacher_reschedule: null,
        minimum_notice_period_for_students_no: null,
        minimum_notice_period_for_students_type: null,
        minimum_notice_period_for_teachers_no: null,
        minimum_notice_period_for_teachers_type: 1,
        notice_period_for_cancellation_no: null,
        notice_period_for_cancellation_type_id: null,
        courseFixedSchedules: [
          {
            schedule_date: '',
            schedule_from_time: '',
            schedule_to_time: '',
            room_id: '',
            users: [],
            ref:null
          }
        ]
      },
      customer_id: localStorage.getItem('customer_id'),
      schedulings: [
        {
          id: 1,
          name: 'Fixed Scheduling',
          selectable: true
        },
        {
          id: 2,
          name: 'Dynamic Scheduling',
          selectable: true
        }
      ],
      deadline: true,

      tutor: true,
      holiday: true,
      course_id: null,
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      teacherList: []
    }
  },
  mounted () {
    this.customer_id = localStorage.getItem('customer_id')
    if (this.course_id) {
      this.getScheduleDetails()
    }
  },
  components: {
    vSelect,
    flatPickr
  },
  methods: {
    async fuseSearch (search) {
      try {
        const payload = {
          name: search
        }

        this.teacher_meta.page = 1
        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
 
      } catch (e) {}
    },
    async loadMoreTeacher ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          this.teacher_meta.page = this.teacher_meta.page + 1
          const payload = {}
          payload.limit = 20
          //payload.course_id = this.course_id
          const { data } = await fetchUserClient(
            'User',
            this.customer_id,
            this.teacher_meta,
            payload
          )
          this.teacherList.push(...data.data.users_list)
          this.teacher_meta = data.data.meta
          this.teacher_meta.page = data.data.meta.current_page
        } catch (e) {
          console.log(e)
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpenTeacher (index) {
      try {
        if (this.teacher_meta.has_next) {
          await this.$nextTick()
          this.observer.observe(document.getElementsByClassName(`loadTeacher${index}`)[0])
        }
      } catch (e) {
        console.log(e)
      }
      
    },
    onCloseTeacher () {
      this.observer.disconnect()
    },
    async getTeacherList () {
      try {
        const payload = {}
        payload.limit = 20
        // payload.course_id = this.course_id
        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async fetchroomList () {
      try {
        const payload = {}
        payload.limit = 20
        payload.course_id = this.course_id
        const responseList = await RoomListApi(
          this.customer_id,
          'Room',
          this.room_meta,
          payload
        )
        this.roomList = responseList.data.data.assets_list
        this.room_meta = responseList.data.data.meta
      } catch (error) {
        console.log(error)
      }
    },
    async onOpenRoom () {
      if (this.room_meta.has_next) {
        await this.$nextTick()
        this.observerRoom.observe(this.$refs.loadRooms)
      }
    },
    onCloseRoom () {
      this.observerRoom.disconnect()
    },
    async loadMoreRooms () {

      try {
        const payload = {}
        payload.limit = 20
        payload.course_id = this.course_id
        this.room_meta.current_page = this.room_meta.current_page + 1
        const responseList = await RoomListApi(
          this.customer_id,
          'Room',
          this.room_meta,
          payload
        )
        this.roomList.push(...responseList.data.data.assets_list)
        this.room_meta = responseList.data.data.meta
      } catch (e) {
        console.log(e)
      }
       
    },
    async prevPage () {
      this.$emit('prevPage', 1)
    },
    async createCourseSchedule () {
      try {
        const validAll = await this.$validator.validateAll('CourseScheduling')

        if (validAll) {
          const res = this.courseScheduleSetting.courseFixedSchedules.map((ele) => {
            return {
              ...ele,
              schedule_from_time:ele.schedule_from_time.length === 5
                ? `${ele.schedule_from_time}:00`
                : ele.schedule_from_time,
              schedule_to_time:ele.schedule_to_time.length === 5
                ? `${ele.schedule_to_time}:00`
                : ele.schedule_to_time

            }
          })
          let deadline = ''
          if (this.courseScheduleSetting.has_enrollment_deadline) {
            deadline = this.courseScheduleSetting.enrollment_deadline.length === 16
              ? `${this.courseScheduleSetting.enrollment_deadline}:00`
              : this.courseScheduleSetting.enrollment_deadline
          }
         
          const newSchedule = {...this.courseScheduleSetting, courseFixedSchedules:res, enrollment_deadline:deadline}
          console.log(newSchedule)

          // if (this.courseScheduleSetting.schedule_type === 1 && this.courseScheduleSetting.courseFixedSchedules.length > 1) {
           
            
          // }
          
          const payload = {
            courseScheduleSetting: newSchedule
          }
          const data = await updateCourseScheduleSetting(
            this.customer_id,
            this.course_id,
            payload
          )
          this.$emit('nextTab', 3)
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please fill the mandatory fields',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            time: 3000
          })
        }

        
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          title: 'Error',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    },
    async getScheduleDetails () {
      try {
        this.schedulings = this.schedulings.map(ele => {
          ele.selectable = true
          return ele
        })
        const data = await getCourseContent(
          this.customer_id,
          this.course_id
        )
        console.log(data.data.data)
        if (data.data.data.course.courseScheduleSetting !== null) {
          this.courseScheduleSetting = data.data.data.course.courseScheduleSetting
        }
        
        this.course_data = data.data.data.course
        console.log(this.course_data.courseStructure.course_type)
        if (this.course_data.courseStructure.course_type.id === 3 || this.course_data.courseStructure.course_type.id === 5) {
          this.schedulings = this.schedulings.map(ele => {
            if (ele.id === 2) ele.selectable = false
            return ele
          })
          
          this.courseScheduleSetting.schedule_type = 1
        }
        if (this.course_data.courseStructure.course_type.id === 2 || this.course_data.courseStructure.course_type.id === 4) {
          this.schedulings = this.schedulings.map(ele => {
            if (ele.id === 1) ele.selectable = false
            return ele
          })
          this.courseScheduleSetting.schedule_type = 2
        }
        console.log(this.schedulings)
        // if (this.course_data.tutors.length > 0 && this.course_data.courseScheduleSetting === null) {
        //   if (this.courseScheduleSetting.courseFixedSchedules) {
        //     this.courseScheduleSetting.courseFixedSchedules[0].users = this.course_data.tutors
        //   }
        // }

        if (this.courseScheduleSetting.courseFixedSchedules.length === 0) {
          this.courseScheduleSetting.courseFixedSchedules.push(
            {
              schedule_date: '',
              schedule_from_time: '',
              schedule_to_time: '',
              room_id: '',
              users: [],
              ref:null
            }
          )
        }
       
       
      } catch (e) {
        console.log(e)
      }
    },
    remove (index) {
      if (this.courseScheduleSetting.courseFixedSchedules.length === 1) {
        this.$vs.notify({
          title: 'Warning',
          text: 'At least one fixed schedule required',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        }) 
      } else {
        this.courseScheduleSetting.courseFixedSchedules.splice(index, 1)
      }
      
    },
    duplicate (schedule_index) {
      if (
        this.courseScheduleSetting.courseFixedSchedules.length <
        this.courseScheduleSetting.no_of_sessions
      ) {
        this.courseScheduleSetting.courseFixedSchedules.push(
          {...this.courseScheduleSetting.courseFixedSchedules[schedule_index]}
        )
        console.log(this.courseScheduleSetting.courseFixedSchedules[this.courseScheduleSetting.courseFixedSchedules.length - 1])
        this.courseScheduleSetting.courseFixedSchedules[this.courseScheduleSetting.courseFixedSchedules.length - 1].id = null
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'All sessions are added',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    }
  }
}
</script>
